import { PRICE_LEVELS, type PriceLevel } from '../constants';

type PriceLevelSelectorProps = {
  value: PriceLevel | null;
  onChange: (value: PriceLevel | null) => void;
  t: any;
};

export default function PriceLevelSelector({ value, onChange, t }: PriceLevelSelectorProps) {
  return (
    <div className="field-group price-level-field">
      <span className="field-label">{t.priceRange} <small>{t.optional}</small></span>
      <div className="price-level-options">
        {PRICE_LEVELS.map((level) => (
          <button
            type="button"
            className={value === level ? 'selected' : ''}
            aria-pressed={value === level}
            onClick={() => onChange(value === level ? null : level)}
            key={level}
          >
            <strong>{'$'.repeat(level)}</strong>
            <span>{t[`priceLevel${level}`]}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
